import {
    GET_RESOURCES_DETAILS_REQUEST,
    GET_RESOURCES_DETAILS_SUCCESS,
    GET_RESOURCES_DETAILS_FAILURE
} from '../actions';


const initialState = {};

const ResourceDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RESOURCES_DETAILS_REQUEST:
            return Object.assign({},state, {asyncStatus:  'PENDING'});
        case GET_RESOURCES_DETAILS_SUCCESS:
            return Object.assign({},state, {asyncStatus:  'SUCCESS', data: action.payload});
        case GET_RESOURCES_DETAILS_FAILURE:
            return Object.assign({},state, {asyncStatus:  'FAILURE', data: action.payload});
        default:
            return state;
    }
};

export default ResourceDetailsReducer